import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
const ProtectedRoute = () => {
    const userToken = localStorage.getItem('user');
    return (
       userToken ? <Outlet/> : <Navigate to={'/login'} />
    );
}
export default ProtectedRoute;